import { render, staticRenderFns } from "./baoxian.vue?vue&type=template&id=645c9c08&scoped=true&"
import script from "./baoxian.vue?vue&type=script&lang=js&"
export * from "./baoxian.vue?vue&type=script&lang=js&"
import style0 from "./baoxian.vue?vue&type=style&index=0&id=645c9c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c9c08",
  null
  
)

export default component.exports